import { FC, useRef } from 'react';
import { VerticalMenuItemWrapper } from '../VerticalMenuItemWrapper';
import { Icon, Tooltip } from '@kontentino/ui';
import useBoolean from 'utils/hooks/useBoolean';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import CreateTooltipContent from 'components/navigation/verticalNavigation/mainMenu/createTooltipContent/CreateTooltipContent';

const MainMenuCreateButton: FC = () => {
  const [isOpen, setIsOpen] = useBoolean(false);
  const tippyRef = useRef<any>(null);
  const { t } = useTranslation();

  return (
    <Tooltip
      content={
        <CreateTooltipContent onRequestClose={() => tippyRef.current?.hide()} />
      }
      placement="right"
      interactive
      interactiveBorder={10}
      interactiveDebounce={100}
      className="tw-w-auto !tw-max-w-none tw-border !tw-border-none !tw-bg-white !tw-p-4 !tw-text-grayscale-180 tw-shadow-2xl"
      appendTo={document.body}
      onCreate={(instance) => {
        tippyRef.current = instance;
      }}
      onShow={() => setIsOpen.on()}
      onHide={() => setIsOpen.off()}
      offset={[65, 14]}
      trigger="mouseenter click"
    >
      <VerticalMenuItemWrapper
        className="tw-flex tw-h-auto tw-min-h-[46px] tw-flex-col tw-items-center tw-gap-1 hover:tw-text-primary-100"
        isActiveMenu={isOpen}
        data-name="navigation-link-plus"
        data-testid="main-menu-create"
      >
        <span className="tw-relative tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center">
          <span
            aria-hidden
            data-testid="create-button-pulse"
            className="tw-pointer-events-none tw-absolute tw-inset-0 tw-animate-ping tw-rounded-full tw-bg-primary-100 tw-opacity-30 motion-reduce:tw-animate-none"
          />
          <button
            type="button"
            aria-label={t('create')}
            className={clsx(
              'tw-relative tw-z-10 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-100 tw-p-1 tw-text-white hover:tw-cursor-pointer hover:tw-bg-primary-120',
              {
                'tw-bg-primary-120': isOpen,
              },
            )}
          >
            <Icon icon={faPlus} size="lg" />
          </button>
        </span>
        <span className="tw-text-center tw-text-[9px] tw-leading-[14px]">
          {t('create')}
        </span>
      </VerticalMenuItemWrapper>
    </Tooltip>
  );
};

export default MainMenuCreateButton;
